import { createSelector } from "@reduxjs/toolkit"
import { calculateBoundingBoxCornerPoints } from "@nova/calculate-geospatial"
import { selectVisibleSatelliteFlights } from "features/entity-caching/flights/selectors"
import { BoundingBoxLayerData } from "plugins/shared/layers/BoundingBoxLayer.class"

export const selectAllSatelliteBoundingBoxes = createSelector(
    [selectVisibleSatelliteFlights],
    (flights) => {
        const boxes: BoundingBoxLayerData[] = []
        flights.forEach((flight) => {
            if (!flight.region.length) return
            const box = calculateBoundingBoxCornerPoints(flight.region)
            const polygon = box.polygon
            const path = [...polygon, polygon[0]]
            boxes.push({ id: flight.id, polygon, path, area: box.area })
        })
        return boxes
    }
)
